// extracted by mini-css-extract-plugin
module.exports = {"regionButton":"regionButton--516c8","scrollY":"scrollY--82320"};